import Vue from 'vue';

export default Vue.component('shimmer-table', {
  template: require('./template.html'),
  name: 'shimmer-table',
  props: {
    rows: {
      type: Number,
      required: false,
      default: 1,
    },
    styles: {
      type: Object,
      require: false,
      default: () => ({}),
    },
  },
});



// WEBPACK FOOTER //
// ./src/mixins/components/shimmers/table/index.js